module.exports = __webpack_public_path__ + "static/media/exm.90d9f07c.png";